module.exports = __webpack_public_path__ + "static/media/lesserglowberry.750b7496.webp";